import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonApiService } from 'src/helper/common-api.service';
import { MessageService } from 'src/helper/message.service';

@Component({
  selector: 'app-sermons',
  templateUrl: './sermons.component.html',
  styleUrls: ['./sermons.component.css'],
})
export class SermonsComponent implements OnInit {
  filtredSermonArray: any = [];
  getSemonArray: any = [];
  getUserArray: any = [];
  filterFrom: FormGroup;
  p = 1;

  constructor(
    private commonApiService: CommonApiService,
    private messageService: MessageService,
    private router: Router,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadForm();
    this.getSermonsDetail();
    this.getUserList();
  }

  paginate(event) {
    this.p = event;
  }

  getSermonsDetail() {
    this.commonApiService
      .getPromiseResponse({
        apiName: '/semon',
        methodType: 'get',
        parameterObject: null,
        showLoading: true,
      })
      .then((result: any) => {
        this.getSemonArray = result;
        this.filtredSermonArray = this.getSemonArray;
        this.ref.detectChanges();
      })
      .catch((err: any) => {});
  }

  handleSemonsClick(item: any) {
    this.router.navigate(['view'], { queryParams: { id: item } });
  }

  convertToLocalDate(utcDate) {
    var date = new Date(utcDate + '.00Z');
    return date.toString();
  }

  loadForm() {
    this.filterFrom = new FormGroup({
      authorId: new FormControl('all'),
      category: new FormControl('all'),
    });

    this.filterFrom.valueChanges.subscribe((t) => {
      this.handleFilter();
    });
  }

  handleFilter() {
    this.filtredSermonArray = [];
    if (
      this.filterFrom.controls.authorId.value != 'all' ||
      this.filterFrom.controls.category.value != 'all'
    ) {
      if (
        this.filterFrom.controls.authorId.value != 'all' &&
        this.filterFrom.controls.category.value != 'all'
      ) {
        this.getSemonArray.forEach((element) => {
          if (
            this.filterFrom.controls.authorId.value == element.authorId &&
            this.filterFrom.controls.category.value == element.category
          ) {
            this.filtredSermonArray.push(element);
          }
        });
      } else if (this.filterFrom.controls.authorId.value != 'all') {
        this.getSemonArray.forEach((element) => {
          if (this.filterFrom.controls.authorId.value == element.authorId) {
            this.filtredSermonArray.push(element);
          }
        });
      } else {
        this.getSemonArray.forEach((element) => {
          if (this.filterFrom.controls.category.value == element.category) {
            this.filtredSermonArray.push(element);
          }
        });
      }
      this.ref.detectChanges();
    } else {
      this.filtredSermonArray = this.getSemonArray;
      this.ref.detectChanges();
    }
  }

  getUserList() {
    this.commonApiService
      .getPromiseResponse({
        apiName: '/api',
        methodType: 'get',
        parameterObject: null,
      })
      .then((result: any) => {
        this.getUserArray = result;

        this.ref.detectChanges();
      })
      .catch((err: any) => {
        if (err.message) {
          this.messageService.warningMessage(err.message);
        } else {
          this.messageService.warningMessage('Something went wrong!');
        }
      });
  }
}
